/**
 * districtNames.js — shared US congressional-district naming helpers.
 *
 * Extracted verbatim from ReportPage.js so BOTH the report studio (ReportPage)
 * and the standalone render route (reportResolve → ReportRenderPage) derive
 * district names/props from ONE source — guaranteeing identical output.
 */
import { stateFipsToName } from "./idUtils";

// State FIPS → USPS abbreviation.
export const FIPS_TO_ABBR = {
  "01": "AL", "02": "AK", "04": "AZ", "05": "AR", "06": "CA",
  "08": "CO", "09": "CT", "10": "DE", "11": "DC", "12": "FL",
  "13": "GA", "15": "HI", "16": "ID", "17": "IL", "18": "IN",
  "19": "IA", "20": "KS", "21": "KY", "22": "LA", "23": "ME",
  "24": "MD", "25": "MA", "26": "MI", "27": "MN", "28": "MS",
  "29": "MO", "30": "MT", "31": "NE", "32": "NV", "33": "NH",
  "34": "NJ", "35": "NM", "36": "NY", "37": "NC", "38": "ND",
  "39": "OH", "40": "OK", "41": "OR", "42": "PA", "44": "RI",
  "45": "SC", "46": "SD", "47": "TN", "48": "TX", "49": "UT",
  "50": "VT", "51": "VA", "53": "WA", "54": "WV", "55": "WI",
  "56": "WY",
};

// Reverse map — USPS abbreviation → state FIPS.
export const ABBR_TO_FIPS = Object.fromEntries(
  Object.entries(FIPS_TO_ABBR).map(([fips, abbr]) => [abbr, fips])
);

// House seats per state. At-large states use 1; the dropdown shows "At-Large".
export const SEATS_BY_STATE = {
  "01": 7,  "02": 1,  "04": 9,  "05": 4,  "06": 52,
  "08": 8,  "09": 5,  "10": 1,  "11": 1,  "12": 28,
  "13": 14, "15": 2,  "16": 2,  "17": 17, "18": 9,
  "19": 4,  "20": 4,  "21": 6,  "22": 6,  "23": 2,
  "24": 8,  "25": 9,  "26": 13, "27": 8,  "28": 4,
  "29": 8,  "30": 2,  "31": 3,  "32": 4,  "33": 2,
  "34": 12, "35": 3,  "36": 26, "37": 14, "38": 1,
  "39": 15, "40": 5,  "41": 6,  "42": 17, "44": 2,
  "45": 7,  "46": 1,  "47": 9,  "48": 38, "49": 4,
  "50": 1,  "51": 11, "53": 10, "54": 2,  "55": 8,
  "56": 1,
};

export function ordinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
}

// districtPadded is a 2-char string ("00".."52"). "00" or a 1-seat state → At-Large.
export function buildDistrictName(fips, districtPadded) {
  const stateName = stateFipsToName[fips] || fips;
  const seatCount = SEATS_BY_STATE[fips] || 53;
  if (seatCount === 1 || districtPadded === "00") return `${stateName} At-Large`;
  const n = Number(districtPadded);
  return `${stateName}'s ${n}${ordinal(n)} Congressional District`;
}
